var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3 47.9H25.7M18 47.9h-3.4a1.8 1.8 0 0 1-1.4-.7l-2.5-3c-.3-.3-.4-.7-.4-1.1V26.8A1.8 1.8 0 0 1 12 25h27.7a7.1 7.1 0 0 1 6 3.1l3.1 4.5c.4.6.9 1.2 1.5 1.6l5.5 3.5a3 3 0 0 1 1.4 2.6v3.4a3 3 0 0 1-2.5 3l-5 .9",
    stroke: "#999CA8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 52.4a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zM46.1 52.4a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z",
    fill: "#FABB1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 31h10.4M5.6 35h7.8M7.3 39.4h6.1M32.9 25a11.5 11.5 0 1 1 14.8 5",
    stroke: "#999CA8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8 12.1v8.2l4.7-2.8M40 28.7l.2 3.5A2.9 2.9 0 0 0 43 35h8.7",
    stroke: "#999CA8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD1);
export default __webpack_public_path__ + "static/media/d1.dbe1e7981fb00774e803a9b566143b0d.svg";
export { ForwardRef as ReactComponent };